import { Dialog, DialogSurface, DialogTitle, Text, Title3, Input, Textarea, RadioGroup, Radio, DialogActions, Button, Field, TableHeaderCell, Subtitle2, Table, TableHeader, TableRow, TableBody, Subtitle1 } from "@fluentui/react-components";
import { FC, useEffect } from "react";
import { TenderAnswer } from "../../../models/tendering";
import { RoleDTO } from "../../../models/role";
import { useAppContext } from "../../../AppContext";
import { DismissRegular } from "@fluentui/react-icons";

interface HistoryDialog {
  change: any;
  open: boolean;
  questionText: string;
  onClose: () => void;
}

const HistoryDialog: FC<HistoryDialog> = ({ change, open, questionText, onClose }) => {
  const {user} = useAppContext();

  useEffect(() => {
    if (open) {
      // Focus the first input element when the dialog opens
      console.log(change)
    }
  }, [open]);

    return (
        <Dialog open={open} onOpenChange={(_, data) => !data.open && onClose()}>
            <DialogSurface>
              <DialogTitle
              action={
              <Button
                shape="circular"
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
                style={{ position: 'absolute', top: '20px', right: '20px' }}
                />
              }>
              <Subtitle1>
                  {change.isIndexing ? `Prisindexering (${change.indexingName})` : "Begär ändring av"}: {questionText}
              </Subtitle1>
              </DialogTitle>
              {user.roles.some((role:RoleDTO) => role.roleType == 'General') && <Text>
                Begärd av: {change.requestedBy}
              </Text>}
              <Table className="mb-5">
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell className="w-20">
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Subtitle2>Svarsvärde</Subtitle2>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Subtitle2>Kommentar:</Subtitle2>
                    </TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  <TableRow>
                    <TableHeaderCell className="w-20">
                      <Subtitle2>Från:</Subtitle2>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Text>{change.oldAnswer.value}</Text>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Text>{change.oldAnswer.comment}</Text>
                    </TableHeaderCell>
                  </TableRow>
                  <TableRow>
                    <TableHeaderCell className="w-20">
                      <Subtitle2>Till:</Subtitle2>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Text>{change.newAnswer.value}</Text>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Text>{change.newAnswer.comment}</Text>
                    </TableHeaderCell>
                  </TableRow>
                </TableBody>
              </Table>
              <DialogActions>
                  <Button appearance="secondary" onClick={onClose}>Stäng</Button>
              </DialogActions>
            </DialogSurface>
        </Dialog>
    );
};

export default HistoryDialog;
